import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as t, unwrap as e } from "../../../../core/maybe.js";

var i = /*#__PURE__*/function () {
  function i(t, e, _i) {
    _classCallCheck(this, i);

    this.editGeometry = t, this.vertex = e, this.pos = _i;
  }

  _createClass(i, [{
    key: "apply",
    value: function apply() {
      var e = t(this.originalPosition);
      e && (this.originalPosition = this.vertex.pos), this._apply(e ? "apply" : "redo");
    }
  }, {
    key: "undo",
    value: function undo() {
      this.vertex.pos = e(this.originalPosition), this.editGeometry.notifyChanges({
        operation: "undo",
        updatedVertices: [this.vertex]
      });
    }
  }, {
    key: "accumulate",
    value: function accumulate(t) {
      return t instanceof i && t.vertex === this.vertex && (this.pos = t.pos, this._apply("apply"), !0);
    }
  }, {
    key: "_apply",
    value: function _apply(t) {
      this.vertex.pos = this.pos, this.editGeometry.components.forEach(function (t) {
        return t.unnormalizeVertexPositions();
      }), this.editGeometry.notifyChanges({
        operation: t,
        updatedVertices: [this.vertex]
      });
    }
  }]);

  return i;
}();

export { i as SetVertexPosition };